<div
  class="banner-style d-flex flex-column flex-lg-row justify-content-between align-items-center rounded"
>
  <!-- Left Side -->
  <div class="d-flex flex-lg-row flex-column align-items-center img-gap">
    <div class="structure">
      <img [src]="image" class="img-fluid" />
    </div>
    <div
      class="heavy pb-10"
      [ngClass]="isMobile ? 'gb-headline6' : 'gb-headline4'"
    >
      <span [innerHTML]="cardTitle"> </span>
      <span class="heavy" [ngClass]="isMobile ? 'gb-headline6' : 'gb-headline4'"
        >{{cardType?.last4CardNumber}}
      </span>
    </div>
  </div>
  <!-- Right Side -->
  <div class="d-flex flex-lg-row flex-column align-items-center">
    <div class="d-flex flex-lg-row flex-column align-items-center">
      <div
        class="heavy"
        [ngClass]="isMobile ? 'gb-headline6' : 'gb-headline5'"
        [innerHTML]="pointTitle"
      ></div>
      <div
        class="heavy pb-4 pl-4"
        [ngClass]="isMobile ? 'gb-headline5' : 'gb-headline3'"
      >
        {{$safeNavigationMigration(earnings?.availableEarnings?.totalPointsConversion)
        | number:'1.0-0'}}
      </div>
    </div>
    <div class="asOf-style strong pl-24">
      <span [innerHTML]="dateTitle"></span>
      <span class="asOf-style-date">{{todayDate}}</span>
    </div>
  </div>
</div>
